/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageComments1 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V12h-2V9h-5V4H6v16h4v2H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M20 14v6.667h-4.176L13.992 22H12v-8zm-6 2v3.52l.912-.662.263-.191H18V16z" />
      </g>
    </g>
  </Icon>
);
export { SvgPageComments1 as PageComments1 };
